// src/components/ui/toaster.tsx
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"
import { cn } from "@/lib/utils"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            // Force bottom animation by adding !important modifier
            className={cn(
              "w-full md:w-auto",
              "data-[state=open]:animate-in data-[state=closed]:animate-out",
              "data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full",
              "data-[state=open]:slide-in-from-bottom-full!", // Added ! to force this animation
              "data-[state=open]:fade-in-80",
              props.className
            )}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription className="break-words">
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport
        className={cn(
          "fixed bottom-0 right-0 flex flex-col p-4",
          "w-full md:max-w-[420px] gap-2",
          // Ensure mobile viewport stays at bottom
          "bottom-0! top-auto!" // Added ! to force bottom positioning
        )}
      />
    </ToastProvider>
  )
}